<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">千橙分销<img class="bgTitle" src="@/assets/images/QcDistribution/bg_title.png" alt="" /></div>
        <div class="line" />
        <div class="desc">
          打造以业务员为核心的超级业务员管理系统
          <div class="desc-content">为企业提供业务员外勤管理、销售管理、订单管理、佣金管理、客户管理等销售辅助功能，全面提升销售业绩；基于企业微信，无缝对接企业商城、ERP、WMS、OMS等企业管理系统，构建全链路全闭环的数字化业务体系。</div>
        </div>
        <div class="btn-wrap">
          <div
            class="btn1"
            @click="openLoginModal"
          >免费试用</div>
          <div
            class="btn"
            @click="openModal"
          >立即咨询</div>
        </div>
      </div>
    </div>
    <!-- <div class="distribution">
      <div class="sk-block-title">
        <div class="title">实体门店经营痛点</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content1.png" alt="">
          <span class="content_title">商品不好管</span>
          <p>店铺商品多、商品议价场景多人工记价乱</p>
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content2.png" alt="">
          <span class="content_title">交易结算慢</span>
          <p>日均开单量大、传统人工结算排队久交易不留痕</p>
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content3.png" alt="">
          <span class="content_title">营销不会做</span>
          <p>老客易流失、新客不转化想做运营无从下手</p>
        </div>
        <div class="item">
          <img src="@/assets/images/qcerpsystem/content4.png" alt="">
          <span class="content_title">数据不清晰</span>
          <p>对账费时费力，无法分析经营状况更换设备数据易丢失</p>
        </div>
      </div>
    </div> -->
    <div class="scene">
      <div class="content1"></div>
    </div>
    <div class="scene1">
      <div class="content2"></div>
    </div>
    <div class="scene">
      <div class="content3"></div>
    </div>
    <div class="scene1">
      <div class="content4"></div>
    </div>
    <div class="scene">
      <div class="content5">
        <div class="goPath" @click="linkTo('QcB2BChannel')" ></div>
      </div>
    </div>
    <div class="programme">
        <div class="sk-block-title" style="padding-top: 48px;">
        <div class="title">开放服务能力，为企业高效、低成本打造专属业务数字化方案</div>
      </div>
      <div class="content">
        <div class="programme_box">
            <div class="programme_box_item_title">实体门店经营痛点</div>
            <div class="programme_box_item_text">可视化业务对象定制，操作便捷，快速适配企业业务特性。</div>
            <div class="programme_ul">
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>10+种字段类型，随意组合使用</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>开箱即用，覆盖客户、线索、拜访、客户服务等多种业务对象和场景</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>可基于业务对象自定义管理规则</span>
                </div>
            </div>
            <img class="box_bg" src="@/assets/images/QcDistribution/programme1.png" alt="">
        </div>
        <div class="programme_box">
            <div class="programme_box_item_title">智能数据分析辅助决策能力</div>
            <div class="programme_box_item_text">基于客户行为、员工销售流程等多种数据分析，助力企业科学决策。</div>
            <div class="programme_ul">
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>多维度数据报表</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>可视化数据中心</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>核心数据日度、周度、月度消息通知</span>
                </div>
            </div>
            <img class="box_bg" src="@/assets/images/QcDistribution/programme2.png" alt="">
        </div>
        <div class="programme_box">
            <div class="programme_box_item_title">智能指挥调度派单能力</div>
            <div class="programme_box_item_text">针对业务对象和流程关键节点，智能派单跟进服务，提升管理效率。</div>
            <div class="programme_ul">
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>智能派单</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>智能规划拜访路径</span>
                </div>
                <div class="programme_li">
                    <img src="@/assets/images/QcDistribution/checked.png" alt="">
                    <span>智能提醒管理员高效派发任务</span>
                </div>
            </div>
            <img class="box_bg" src="@/assets/images/QcDistribution/programme3.png" alt="">
        </div>
      </div>
    </div>
    <div class="custom">
      <div class="sk-block-title1">
        <div class="title1">客户案例</div>
      </div>
      <div class="content">
        <el-carousel :autoplay="false" :interval="5000" arrow="always">
          <el-carousel-item>
            <div class="custom_item">
              <img src="@/assets/images/QcDistribution/custom_bg1.png" alt="">
              <div class="custom_item_text">
                <div class="title">某供应链公司</div>
                <div class="text">面向中小企业客户的交易和服务平台。借助千橙分销，实现对用户的精细化运营管理，通过有效的互动、运营方式，打通线上线下采购渠道，以提升客户经营能力，实现业绩增长。</div>
                <div class="cutom_box">
                <div class="box_item">
                    <div class="box_title">53%</div>
                    <div class="box_line"></div>
                    <div class="box_span">运营效率提升</div>
                </div>
                <div class="box_item">
                    <div class="box_title">30%</div>
                    <div class="box_line"></div>
                    <div class="box_span">业绩增长</div>
                </div>
              </div>
            </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="custom_item">
              <img src="@/assets/images/QcDistribution/custom_bg3.png" alt="">
              <div class="custom_item_text">
                <div class="title">某二手车服务机构</div>
                <div class="text">打通千橙分销与企业业务系统，打通员工和企业客户数据，通过外勤管理和任务中心，激活组织活力，提升商机线索获取效率，通过代客下单缩短转化链路，提升交易转化。</div>
                <div class="cutom_box">
                <div class="box_item">
                    <div class="box_title">10</div>
                    <div class="box_line"></div>
                    <div class="box_span">节省人力</div>
                </div>
                <div class="box_item">
                    <div class="box_title">25%</div>
                    <div class="box_line"></div>
                    <div class="box_span">交易转化提升</div>
                </div>
              </div>
            </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="custom_item">
              <img src="@/assets/images/QcDistribution/custom_bg2.png" alt="">
              <div class="custom_item_text">
                <div class="title">某3C批发零售企业</div>
                <div class="text">借助千橙分销和分销商城，快速构建自有用户池，通过询报价工具，提升询报价效率，通过分销商城实现交易闭环，缩短分销链路。打造询价、报价到采购交易的全流程闭环，以提升运营效率和分销转化率。</div>
                <div class="cutom_box">
                <div class="box_item">
                    <div class="box_title">50%</div>
                    <div class="box_line"></div>
                    <div class="box_span">运营效率提升</div>
                </div>
                <div class="box_item">
                    <div class="box_title">15</div>
                    <div class="box_line"></div>
                    <div class="box_span">业绩增长</div>
                </div>
              </div>
            </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="service">
      <div class="sk-block-title1">
        <div class="title1">专注分销领域，专业团队服务</div>
      </div>
      <div class="content">
        <div class="service_box">
            <img src="@/assets/images/QcDistribution/box1.png" alt="">
            <div class="box_title">专业团队</div>
            <div class="box_text">专业产研团队，具备全面的产品架构经验</div>
        </div>
        <div class="service_box">
            <img src="@/assets/images/QcDistribution/box2.png" alt="">
            <div class="box_title">产品使用培训</div>
            <div class="box_text">远程指导及服务现场演示和培训</div>
        </div>
        <div class="service_box">
            <img src="@/assets/images/QcDistribution/box3.png" alt="">
            <div class="box_title">客户成功</div>
            <div class="box_text">以客户为中心，深度服务，助力企业实现分销增长</div>
        </div>
        <div class="service_box">
            <img src="@/assets/images/QcDistribution/box4.png" alt="">
            <div class="box_title">数据安全</div>
            <div class="box_text">企业数据加密存储，秘钥完全独立，从源头保护企业数据安全</div>
        </div>
        <div class="service_box">
            <img src="@/assets/images/QcDistribution/box5.png" alt="">
            <div class="box_title">解决方案咨询</div>
            <div class="box_text">专注B2b分销场景，丰富的渠道分销运营经验</div>
        </div>
      </div>
    </div>
    <Contact :infoSources="'汇通数科官网-千橙分销'" />
    <TryModal v-if="visible" :visible="visible" info-sources="社群分销" @cancel="modalClose" />
    <LoginModal
            v-if="showLogin"
            :showLogin="showLogin"
            @cancel="loginModalClose"
            :isLogin="isLogin"
            :selectValue="'6'"
        />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import TryModal from '@/components/TryModal'
import Contact from '@/components/Contact'
import LoginModal from '@/components/LoginModal'

export default {
  metaInfo: metaInfo.QcDistribution,
  components: {
    TryModal,
    Contact,
    LoginModal
  },
  data() {
    return {
      visible: false,
      toolBg: require('@/assets/images/QcCashier/tool1.png'),
      tooItem: '1',
      showLogin:false,//是否展示注册弹框
      isLogin:false,//是否注册
    }
  },
  mounted() {

  },
  methods: {
    linkTo(path) {
      if (!path.startsWith("/")) {
        path = "/" + path;
      }
      this.$router.push({ path });
      browseCount();
    },
    // 是否需要显示二维码
    openLoginModal() {
        this.showLogin = true
        this.isLogin = false
    },
    loginModalClose(data) {
        this.showLogin = data;
    },
    checkBg(item) {
      this.tooItem = item
      this.toolBg = '@/assets/images/QcCashier/tool' + item + '.png'
    },
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
.bgTitle{
    width:117px;
    height:22px;
    margin-left:12px;
}
/deep/ i.el-icon-arrow-left {
    font-size: 35px;
    font-weight: 600;
}
/deep/ i.el-icon-arrow-right{
    font-size: 35px;
    font-weight: 600;
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--left,button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
/deep/ button.el-carousel__arrow.el-carousel__arrow--right {
    width: 50px;
    height: 86px;
    border-radius: 0px;
    background-color: rgba(0,0,0,.4);
}
.service{
    height: 510px;
    background: #F9FBFE;
    display: flex;
    flex-direction: column;
    align-items:center;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        display: flex;
        flex-direction: row;
        height: 255px;
        justify-content: space-between;
        .service_box{
            width:192px;
            display: flex;
            flex-direction: column;
            height: 255px;
            justify-content: space-between;
            align-items: center;
            img{
                width:160px;
                height:120px;
            }
            .box_title{
                // width: 80px;
height: 30px;
font-size: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 30px;
            }
            .box_text{
                // width: 192px;
height: 72px;
font-size: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
color: #333333;
line-height: 24px;
            }
        }
    }
}
.custom{
        height:662px;
        background: url("~@/assets/images/qcerpsystem/carousel_bg.png") no-repeat center;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items:center;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        text-align: left;
        background: rgba(255,255,255,.5);
        // background: #FFFFFF;
        // opacity: 0.55;
        // border-radius: 8px;
        margin-top: 42px;
        height:439px;
        .custom_item{
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding:0 150px;
            .cutom_box{
                width:260px;
                height:89px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-top:140px;
                .box_item{
                    display: flex;
                    flex-direction: column;
                    .box_title{
                        width: 71px;
                        height: 45px;
                        font-size: 32px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        line-height: 45px;
                    }
                    .box_line{
                        width: 43px;
                        height: 5px;
                        background: #3986FF;
                    }
                    .box_span{
                        width: 96px;
height: 22px;
font-size: 16px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
color: #595961;
line-height: 22px;
                    }
                }
            }
            .custom_item_text{
                margin-left: 50px;
                .title{
                    height: 40px;
                    font-size: 22px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    line-height: 40px;
                }
                .text{
                    height: 20px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 20px;
                    margin-top:30px;
                }
            }
            img{
                width: 438px;
                height: 302px;
            }
        }
    }
}
.case{
    background: #F8FBFF;
    .content{
        width: 1200px;
        margin: 0 auto;
        padding: 53px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 1171px;
            height:397px;
        }
    }
}
.content_title{
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
}
.content-center {
    ul,
    li {
    list-style: disc;
    }
  // .banner {
  //   background: url("~@/assets/images/community/community_banner.png") no-repeat center;
  //   min-width: 1200px;
  //   .btn-wrap {
  //     width: 1200px;
  //     margin: 0 auto;
  //     padding: 309px 0 53px;
  //     .btn {
  //       width: 200px;
  //       height: 58px;
  //       line-height: 58px;
  //       border-radius: 6px;
  //       border: 1px solid #FFFFFF;
  //       font-size: 22px;
  //       color: #FFFFFF;
  //       cursor: pointer;
  //     }
  //   }
  // }
  .banner {
    background: url("~@/assets/images/qcerpsystem/qcerpsystem_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 675px;
        height: 124px;
        font-size: 20px;
        color: #FFFFFF;
        font-weight: normal;
        line-height: 28px;
        .desc-content{
            width: 618px;
            height: 96px;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 32px;
            margin-top:7px;
        }
      }
      .btn-wrap {
        display: flex;
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
          margin-left:20px;
        }
        .btn1 {
          width: 200px;
          height: 58px;
          line-height: 58px;
          background: #3986FF;
          border-radius: 6px;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        //   margin-left:20px;
        }
      }
    }
  }
  .distribution {
    background: #FFFFFF;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 0 auto;
      padding: 60px 0 124px 0;
      .item {
        display: flex;
        flex-shrink: 0;
        flex-direction: column;
        width: 238px;
        height: 340px;
        // background: #FFFFFF;
        // box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        // border-radius: 6px;
        justify-content: center;
        align-items: center;
        padding: 28px 28px;
        // background: fixed url("~@/assets/images/qcerpsystem/content_bg.png") no-repeat center;
        // background-size: 100% 100%;
        img {
          width: 144px;
          height: 144px;
        }
        span {
          margin-top: 12px;
          height: 28px;
          font-size: 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 28px;
        }
        div {
          margin-top: 12px;
          width: 40px;
          height: 6px;
          background: #2F81E8;
        }
        p {
          margin-top: 6px;
          width: 219px;
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }
    }
  }
  .shop {
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    .content {
      width: 1200px;
      height:503px;
      text-align: center;
      margin: 17px 0 51px 0;
      background: url("~@/assets/images/qcerpsystem/shop_bg.png") no-repeat center;
      background-size: 1200px 503px;
      .content_left{
        width: 300px;
        padding: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        float: right;
        .content_box{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 40px;
           .content_box_left{
                width: 24px;
                img{
                    width: 24px;
                    height: 24px;
                }
           }
           .content_box_right{
                width: 200px;
                text-align: left;
                // height: 33px;
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 33px;
           }
        }
     }
    }
  }
  .sub-title {
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 42px;
    margin-bottom:20px;
      }
      .sub-content {
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 36px;
      }
  .sharp {
    background: #F8FBFF;
    .content {
      width: 1159px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 57px 0 60px 0;
      .right {
        width: 578px;
        text-align: left;
      }
      img{
        width: 612px;
        height: 368px;
      }

    }
  }
  .content-box{
      display: flex;
      flex-direction: row;
      margin-top: 52px;
      .content-box-left{
          width:24px;
          display: flex;
          align-items: center;
          img{
              width: 24px;
              height: 24px;
          }
      }
      .content-box-right{
        //   width: 383px;
          height: 28px;
        font-size: 20px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 28px;
          margin-left:15px;
      }

  }
  .coreFun {
    padding-bottom: 73px;
    // background: #FAFAFA;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1179px;
      margin: 60px auto 0;
      .left {
        width: 600px;
        text-align: left;
      }
      .content_bg{
        width: 612px;
        height: 368px;
      }

    }
  }
  .programme{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #F8F9FB;
    height: 667px;
    .content{
        width: 1200px;
        height:458px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top:60px;
        .programme_box{
            width: 321px;
            height: 458px;
            background: #FFFFFF;
            border-radius: 8px;
            padding-left:20px;
            position: relative;
            .box_bg{
                width: 276px;
                height: 222px;
                position: absolute;
                bottom:0;
                left:2px;
            }
            .programme_ul{
                width: 301px;
                display: flex;
                flex-direction: column;
                margin-top:32px;
                .programme_li{
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    margin-bottom:15px;
                    img{
                        width:14px;
                        height:14px;
                        margin-right:8px;
                        margin-top:3px;
                    }
                    span{
                        width: 226px;
                        // height: 40px;
                        font-size: 14px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #595961;
                        line-height: 20px;
                        text-align: left;
                    }
                }
            }
            .programme_box_item_title{
                height: 28px;
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                color: #595961;
                line-height: 28px;
                text-align: left;
                margin-top: 30px;
            }
            .programme_box_item_text{
                width: 301px;
                height: 44px;
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #595961;
                line-height: 22px;
                text-align: left;
                margin-top: 16px;
            }
        }
    }
  }
  .scene1{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fb;
    .content2 {
      width: 1920px;
      height:685px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg2.png") no-repeat center;
      background-size: 1920px 685px;
    }
    .content4 {
      width: 1920px;
      height:649px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg4.png") no-repeat center;
      background-size: 1920px 649px;
    }
  }
  .scene {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    .content1 {
      width: 1920px;
      height:836px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg1.png") no-repeat center;
      background-size: 1920px 836px;
    }
    .content3 {
      width: 1920px;
      height:685px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg3.png") no-repeat center;
      background-size: 1920px 685px;
    }
    .content5 {
      width: 1920px;
      height:674px;
      text-align: center;
      background: url("~@/assets/images/QcDistribution/scene_bg5.png") no-repeat center;
      background-size: 1920px 674px;
      position: relative;
      .goPath{
        position: absolute;
        width:200px;
      height:20px;
      left: 1417px;
    top: 269px;
    cursor: pointer;
      }
    }
  }
}
</style>
